import { render } from "./SkillCards.vue?vue&type=template&id=6b8ded86&scoped=true"
import script from "./SkillCards.vue?vue&type=script&lang=js"
export * from "./SkillCards.vue?vue&type=script&lang=js"

import "./SkillCards.vue?vue&type=style&index=0&id=6b8ded86&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8ded86"]])

export default __exports__